import { RouteProps } from "react-router";
import { UserRole } from "../types/user";

const routes = (type: UserRole): RouteProps[] =>
  require(`./${type.toLowerCase()}`).default;
export default routes;
